import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class OnboardingStartGuard implements CanActivate {

    constructor(
        private router: Router,
        protected authService: AuthService,
    ) { 
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        try {
            const loggedIn = await this.authService.isLoggedIn();
            
            if (loggedIn) {
                this.router.navigate(['../tabs/home']);
                return false;
            }

            return true;
        } catch(err) {
            return false;
        }
    }

}